import {
  type AssertionLoginResult,
  ChallengeType,
  type RequestAttestation,
} from '~/interfaces/auth';

import { LoginHandler } from './login-handler';

export class MetaMaskHandler extends LoginHandler<
  Omit<RequestAttestation, 'data'>,
  AssertionLoginResult
> {
  protected transformRequestBody(
    body: Omit<RequestAttestation, 'data'>,
  ): AssertionLoginResult {
    if (!body.sig || !body.alias || !body.originalChallengeParams) {
      throw new Error('Invalid request body');
    }

    return {
      assertion_result: {
        challengeType: ChallengeType.SIGNING_CHALLENGE,
        alias: body.alias,
        value: {
          signature: body.sig,
          alias: body.alias,
        },
        originalChallengeParams: body.originalChallengeParams,
      },
      extra_context: {},
    };
  }
}
